const pageloadSplash =  document.querySelector(".js-pageload-splash");

if (typeof pageloadSplash != "undefined" && pageloadSplash != null) {

    const splashText = pageloadSplash.querySelector('.js-splash-text')
    const splashImg = pageloadSplash.querySelector('.js-splash-img')
    const openingTl = gsap.timeline({onComplete: document.body.classList.remove("stop-scrolling")});
    
    openingTl

    .to(splashText, {
        autoAlpha: 1,
        duration: 0.6,
        delay: 0.3,
        ease: "power3.inOut"
    })

    .to(splashText, {
        height: '100%',
        duration: 0.6,
        delay: -0.3,
        ease: "power3.inOut"
    })

    .to(splashImg, {
        autoAlpha: 1,
        duration: 0.6,
        delay: -0.3,
        ease: "power1.inOut"
    })

    .to(pageloadSplash, {
        autoAlpha: 0,
        duration: 0.6,
        delay: 0.6,
        ease: "power3.inOut"
    })
}